import { ActionTree, ActionContext } from 'vuex';

import { RootStateI } from '../state';
import { NotificationStateI } from './state';

export const actions: ActionTree<NotificationStateI, RootStateI> = {
};
